import { render, staticRenderFns } from "./yujingzhishezhi.vue?vue&type=template&id=0ec7be81&scoped=true"
import script from "./yujingzhishezhi.vue?vue&type=script&lang=js"
export * from "./yujingzhishezhi.vue?vue&type=script&lang=js"
import style0 from "./yujingzhishezhi.vue?vue&type=style&index=0&id=0ec7be81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7be81",
  null
  
)

export default component.exports